import React from "react";
import PageContainer from "../../components/PageContainer";
import AboutUsHeader from "./AboutUsHeader";
import { Col, Divider, Row } from "antd";
import { MailOutlined } from "@ant-design/icons";
import ExpandableBox from "../../components/ExpandableBox/ExpandableBox";

function AboutUs() {
  return (
    <>
      <PageContainer
        classNames="about-us"
        headerProps={{
          right: "",
          link: "/menu",
          tall: true,
          content: "",
          children: <AboutUsHeader />,
          className: "about-us",
        }}
      >
        <Row>
          <Col
            span={24}
            push={0}
            // md={{ span: 20, push: 2 }}
            style={{ textAlign: "justify" }}
          >
            <ExpandableBox closable={false}>
              <p>
                بازار ارائه خدمات حقوقی در کشور ما چه از سمت مشتریان این بازار و
                چه از سمت ارائه کنندگان خدمات حقوقی که عمدتاً وکلای دادگستری
                هستند با چالشهای متعددی روبرو است.
              </p>
              <h4>
                الف: پاسخ ما به مشکلات و چالشهای مشتریان در بازار خدمات حقوقی:
              </h4>
              <ul>
                <li>
                  مشتریان در گام اول برای انتخاب وکیل صلاحیتدار و متخصص در موضوع
                  مورد نیازشان با مشکل مواجه هستند.
                </li>
                <li>
                  چالش دوم برای مشتریان اطمینان از کیفیت مطلوب خدمات وکیل می
                  باشد که اساساً ساز و کاری برای این منظور در اختیار مشتریان نمی
                  باشد.
                </li>
                <li>
                  چالش سوم ارزیابی بهای خدمات است. وکلا به طور موردی قیمت
                  متفاوتی برای خدمات یکسان اعلام می کنند و مشتریان از چگونگی و
                  منصفانه بودن قیمت آگاهی ندارند.
                </li>
              </ul>
              <h4>
                لاوین هر سه چالش ذکر شده را به شرح زیر برای مشتریان حل نموده
                است:
              </h4>
              <ul>
                <li>
                  پس از انتخاب یک خدمت در لاوین صرفاً به وکلای متخصص در آن رشته
                  ارجاع خواهید شد و صلاحیت تخصصی وکلا قبلاً توسط تیم تخصصی لاوین
                  بررسی شده است.
                </li>
                <li>
                  کلیه خدمات در بستر اپلیکیشن انجام و ثبت و ضبط می گردد و در هر
                  زمان کیفیت خدمات قابل بررسی و کنترل توسط تیم لاوین یا هر مرجع
                  دیگری می باشد و به وکلا اجازه داده شده است تا در صورتی که دانش
                  و آگاهی لازم را ندارند و یا تردیدی در خصوص پاسخ دارند موضوع را
                  به وکلای دیگر ارجاع دهند.
                </li>
                <li>
                  قیمت گذاری منصفانه خدمات توسط لاوین انجام شده است و قیمت به
                  طور یکسان برای همه مشتریان و توسط اپلیکیشن محاسبه می گردد و
                  وکلا هیچگونه دخالتی در قیمت گذاری نداشته و تحت هیچ شرایطی حق
                  مطالبه وجهی از موکلین را تحت هر عنوان ندارند.
                </li>
              </ul>
              <p>
                در کنار حل چالشهای بزرگ ذکر شده، لاوین دسترسی مردم در سطح کشور
                را به خدمات با کیفیت وکالت درهر نقطه از کشور را فراهم می کند و
                شما می توانید با آرامش خاطر از خدمات وکلای متخصص بهره مند شوید و
                یا نسبت به انتخاب وکیل خود جهت دفاع در دادگاه اقدام نمایید؛ بدون
                اینکه نیاز به حضور در دفتر وکیل یا هر مکان دیگری داشته باشید.
              </p>
              <p>
                با ما همراه شوید و اپلیکیشن لاوین را نصب کنید و از خدمات ویژه ما
                استفاده کنید.
              </p>
              <h4>ب: پاسخ ما به چالشها و مشکلات وکلا:</h4>
              <ul>
                <li>
                  وکلا عمدتاً مایل هستند تا در یک رشته تخصصی که تجربه و دانش
                  بیشتری در آن رشته دارند فعالیت نمایند. لاوین زمینه تخصصی شدن
                  وکالت را فراهم آورده است و صرفاً تقاضاهای مرتبط با تخصص وکلا
                  را به آنها ارجاع می دهد.
                </li>
                <li>
                  حضور وکلا در لاوین کاملاً محرمانه می باشد و پس از پذیرش خدمت،
                  هویت وکیل صرفاً برای موکل مشخص می شود.
                </li>
                <li>
                  با ایجاد مرکز نمونه قراردادها و اسناد حقوقی، تجربیات وکلا به
                  اشتراک گذاشته شده است و هر وکیل می تواند در زمینه تخصصی فعالیت
                  خود را از تجربیات سایر همکاران خود استفاده نماید.
                </li>
                <li>
                  لاوین دفتر مجازی وکلای دادگستری ایران می باشد و شما همکاران
                  عزیز را از نیاز به دفتر و هزینه های جانبی آن بی نیاز می کند.
                  شما به راحتی می توانید فعالیت خود را در لاوین متمرکز نموده و
                  به ارائه خدمات مشاوره حقوقی یا پذیرش وکالت پرونده ها در هر
                  زمان و هر مکان که مایل هستید اقدام نمایید.
                </li>
                <li>
                  وکلایی که از سطح رضایتمندی بیشتری از ناحیه موکلین برخوردار
                  باشند یا فعالیت بیشتری داشته باشند در ارجاع کارها در اولویت
                  قرار می گیرند و این اولویت بندی به طور خودکار توسط اپلیکیشن
                  اعمال می گردد.
                </li>
                <li>
                  لاوین متعهد به پرداخت حق الزحمه وکلا می باشد و وکلا از ورود به
                  مسائل مالی موکلین منع شده اند.
                </li>
              </ul>

              <p>
                آنچه ذکر شده تنها بخشی از ویژگی های ارائه خدمات حقوقی در لاوین
                است، همکاران ما در تیم های حقوقی، فنی و مدیریت تمام تلاش خود را
                برای ارائه سطحی کاملا متفاوت از خدمات صرف می نمایند و پیوسته در
                کنار شما هستند تا شما با اطمینان خاطر تجارت کنید، زندگی کنید و
                برای اهداف و آمال بزرگ خود برنامه ریزی کنید.
              </p>
            </ExpandableBox>

            <div className="contact-us">
              <div className="title">تماس با ما</div>
              <div className="wrapper">
                <div className="phone-number">
                  <span className="icon-lbs-3" />
                  <div className="title">شماره تماس :</div>
                  <div>
                    <a href="tel:+982122710000" className="text">
                      021-22710000
                    </a>
                  </div>
                </div>
                <Divider />
                <div className="email">
                  <MailOutlined />
                  <div className="title">ایمیل :</div>
                  <a
                    href="mailto:info@lavin.one"
                    className="text"
                    target={"_blank"}
                    rel="noopener noreferrer"
                  >
                    info@lavin.one
                  </a>
                </div>
                <Divider />
                <div className="address">
                  <span className="icon-lbs-marker-3" />
                  <div className="title">آدرس :</div>
                  <div>
                    <a
                      href="https://maps.google.com/?q=35.81022,51.44867"
                      className="text"
                      target={"_blank"}
                      rel="noopener noreferrer"
                    >
                      تهران- نیاوران- خیابان عمار (میرانصاری)- نبش کوچه صابر-
                      پلاک 12 طبقه 7 واحد 13
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </Col>
        </Row>
        <div className="footer">
          <div className="text">
            تمامی حقوق مادی و معنوی اپلیکیشن های لاوین متعلق به شرکت داد و خرد
            لاوین می باشد.
          </div>
        </div>
      </PageContainer>
    </>
  );
}

export default AboutUs;
